import * as z from "zod";

export const commerceAgentRevenueGranularitySchema = z.enum([
  "day",
  "week",
  "month",
]);
export type CommerceAgentRevenueGranularity = z.infer<
  typeof commerceAgentRevenueGranularitySchema
>;

const revenueStreamSchema = z.object({
  revenueMicros: z.number().int(),
  invoiceCount: z.number().int().nonnegative(),
});

const commerceAgentRevenueReportSchema = z.object({
  currency: z.literal("USD"),
  totalRevenueMicros: z.number().int(),
  streams: z.object({
    recover: revenueStreamSchema,
    inbound: revenueStreamSchema.extend({
      messageCredits: z.number().int().nonnegative(),
      missingBreakdownInvoiceCount: z.number().int().nonnegative(),
    }),
    support: revenueStreamSchema.extend({
      resolutionCount: z.number().int().nonnegative(),
    }),
  }),
  series: z.array(
    z.object({
      periodStart: z.string(),
      recoverRevenueMicros: z.number().int(),
      inboundRevenueMicros: z.number().int(),
      supportRevenueMicros: z.number().int(),
      totalRevenueMicros: z.number().int(),
    }),
  ),
});

export type CommerceAgentRevenueReport = z.infer<
  typeof commerceAgentRevenueReportSchema
>;

export const getCommerceAgentRevenue = {
  name: "getCommerceAgentRevenue" as const,
  input: z
    .object({
      start: z.date(),
      end: z.date(),
      granularity: commerceAgentRevenueGranularitySchema,
    })
    .refine(({ start, end }) => end > start, {
      message: "End must be after start",
    }),
  output: commerceAgentRevenueReportSchema,
};
